export default __webpack_public_path__ + "static/media/icons8-microsoft-sql-server.87192a7b.svg";